import graphqlClient from "../../../apollo";

class ListaPreciosVentaProvider {
  list() {
    return graphqlClient.query({
      query: require("./gql/listaPreciosVentaList.graphql"),
      fetchPolicy: "network-only",
    });
  }

  find(id) {
    return graphqlClient.query({
      query: require("./gql/listaPreciosVentaFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  productoPreciosLista(productoId) {
    return graphqlClient.query({
      query: require("./gql/productoPreciosLista.graphql"),
      variables: { productoId },
      fetchPolicy: "network-only",
    });
  }

  productosPreciosVenta(productoIds, listaPreciosId = null) {
    return graphqlClient.query({
      query: require("./gql/productosPreciosVenta.graphql"),
      variables: { productoIds, listaPreciosId },
      fetchPolicy: "network-only",
    });
  }

  create(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/listaPreciosVentaCreate.graphql"),
      variables: { input },
    });
  }

  update(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/listaPreciosVentaUpdate.graphql"),
      variables: { id, input },
    });
  }

  delete(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/listaPreciosVentaDelete.graphql"),
      variables: { id },
    });
  }

  setMargen(productoId, listaPreciosId, margenOverride) {
    return graphqlClient.mutate({
      mutation: require("./gql/productoPrecioListaSetMargen.graphql"),
      variables: { productoId, listaPreciosId, margenOverride },
    });
  }

  setOverride(productoId, listaPreciosId, precioVentaOverride) {
    return graphqlClient.mutate({
      mutation: require("./gql/productoPrecioListaSetOverride.graphql"),
      variables: { productoId, listaPreciosId, precioVentaOverride },
    });
  }
}

export default new ListaPreciosVentaProvider();
